import { TableRow } from '@unimed-fesp/components';
import React from 'react';
import { CustomTableHeader } from './styles';

const TableHeaderRelatorios = () => {
  return (
    <TableRow>
      <CustomTableHeader>Nome Arquivo</CustomTableHeader>
      <CustomTableHeader>Status</CustomTableHeader>
      <CustomTableHeader>Data da Solicitação</CustomTableHeader>
      <CustomTableHeader>Data da Finalização</CustomTableHeader>
      <CustomTableHeader>Ações</CustomTableHeader>
    </TableRow>
  );
};

export default TableHeaderRelatorios;
